var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 211.3 185.1",
    style: {
      enableBackground: "new 0 0 211.3 185.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#252A36;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.6,95.5L143.6,95.5l-71.4,0l0,64.4l0,11.6c0,5,4.1,9.1,9.1,9.1l116.4,0c5,0,9.1-4.1,9.1-9.1l0-76 L143.6,95.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.1,35.3V24.9H4.5v76c0,5,4.1,9.1,9.1,9.1h20.3V48.9c0-7.5,6.1-13.6,13.6-13.6H139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.7,70.5h-20.3V48.9c0-7.5-6.1-13.6-13.6-13.6h-20.3V13.6C143.6,6.1,137.5,0,130,0H13.6 C6.1,0,0,6.1,0,13.6V101c0,7.5,6.1,13.6,13.6,13.6h20.3v21.7c0,7.5,6.1,13.6,13.6,13.6h20.3v21.7c0,7.5,6.1,13.6,13.6,13.6h116.4 c7.5,0,13.6-6.1,13.6-13.6V84.1C211.3,76.6,205.2,70.5,197.7,70.5z M33.8,48.9v61.2H13.6c-5,0-9.1-4.1-9.1-9.1v-76h134.6v10.3 H47.4C39.9,35.3,33.8,41.4,33.8,48.9z M197.7,180.6l-116.4,0c-5,0-9.1-4.1-9.1-9.1l0-11.6l0-64.4l71.4,0v0l63.2,0l0,76 C206.8,176.5,202.7,180.6,197.7,180.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M135.7,60.2H38.4v47.7v2.1v-2.1h0v10.4h0v-3.8v3.8v17.9c0,5,4.1,9.1,9.1,9.1h20.3v-30.8h0v3.8v-3.8v-4.5v-2.1 v2.1h0V84.1c0-7.5,6.1-13.6,13.6-13.6h84.4h7.3V60.2h-18.3H135.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindow);
export default __webpack_public_path__ + "static/media/window.adc6897353f54b3c5db751e92d81cedc.svg";
export { ForwardRef as ReactComponent };